import { render } from "./cheque.vue?vue&type=template&id=5cca8b11&scoped=true"
import script from "./cheque.vue?vue&type=script&lang=js"
export * from "./cheque.vue?vue&type=script&lang=js"

import "./cheque.vue?vue&type=style&index=0&id=5cca8b11&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cca8b11"]])

export default __exports__